import EventEmitter from 'events';

const parseEventData = (data) => {
  try {
    const { action = '', payload = {} } = JSON.parse(data);
    return { action, payload };
  } catch (e) {
    return { action: '', payload: {} };
  }
};

export default class CrossWindowMessenger extends EventEmitter {
  constructor(targetWindow) {
    super();
    this.targetWindow = targetWindow;
    this.onMessage = this.onMessage.bind(this);
    window.addEventListener('message', this.onMessage);
  }

  destroy() {
    window.removeEventListener('message', this.onMessage);
    this.targetWindow = undefined;
    this.removeAllListeners();
  }

  onMessage(event) {
    if (event.origin !== window.location.origin) {
      return;
    }

    const { action, payload } = parseEventData(event.data);
    this.emit(action, payload, event);
  }

  postMessage(action = '', payload = {}) {
    if (!this.targetWindow) {
      return;
    }

    const message = JSON.stringify({ action, payload });
    this.targetWindow.postMessage(message, window.location.origin);
  }
}
